import React, {useState, useEffect, memo} from 'react'
import {Redirect} from 'react-router-dom'
import {ServerConfig} from 'config'
import axios from 'axios'
import {useSelector} from 'react-redux'

import loading_gif from '../../assets/img/loading.gif'

import Select from 'react-select';
import SortableTbl from "react-sort-search-table";
import DatePicker from "react-datepicker";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

import "react-datepicker/dist/react-datepicker.css";

import {makeStyles} from '@material-ui/core/styles'
import {Typography, Grid, Checkbox, Button} from '@material-ui/core'

import _ from 'lodash'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

const useStyles = makeStyles((theme) => ({
  	datePickerPopper: {
        zIndex: '999 !important',
    },
}))


const Cashdrawers = () => {
  const token = useSelector(state => state.auth.access_token)

  const tenant = useSelector(state => state.auth.tenant)
  console.log(tenant);
  console.log(tenant.state);

  const [selectedCashdrawerIdForManual, setSelectedCashdrawerIdForManual] = useState()
  const [changeDollars, setChangeDollars] = useState(0)

  const [availableCashdrawers, setAvailableCashdrawers] = useState([])
  const [selectedCashdrawerId, setSelectedCashdrawerId] = useState()
  const [dailySummaries, setDailySummaries] = useState([])
  const [cashdrawerBalances, setCashdrawerBalances] = useState([])

  let date_before_one_day = new Date();
  date_before_one_day.setDate(date_before_one_day.getDate() - 1);
  const [startDate, setStartDate] = useState(date_before_one_day);

  const [endDate, setEndDate] = useState(new Date());

  const [cols, setCols] = useState(["datetime", "value_dollars", "balance_dollars", "ledger_id"]);
  const [heads, setHeads] = useState(["Datetime", "Amount", "Balance", "Ledger ID"]);

  const [isLoading, setIsLoading] = useState(false);

  const classes = useStyles()

  async function fetchCashdrawerList(token) {
    const config = {headers: {'Content-Type': 'application/json'}}

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const results = await axios.get(`${ServerConfig.SERVER_URL}/tenant/tenant_cashdrawers`, config);
    const options = [];

    for (let idx in results.data) {
      options.push({value: results.data[idx].id, label: results.data[idx].name});
    }
    setAvailableCashdrawers(options)

    /*if(options.length > 0) {
      setSelectedCashdrawerId(options[0].value)
    }*/
  }

  async function fetchCashdrawerBalances(token){
    setIsLoading(true);

    const config = {headers: {'Content-Type': 'application/json'}}

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const results = await axios.get(`${ServerConfig.SERVER_URL}/tenant/tenant_cashdrawers/balances`,  config)
    for (let idx in results.data) {
      console.log("Processing idx: " + idx);

      let dollarbalance = "$" + (results.data[idx].balance / 1e6).toFixed(2);
      _.extend(results.data[idx], {'dollarbalance': dollarbalance});
    }

    setCashdrawerBalances(results.data)
    setIsLoading(false);
  }

  async function insertManualTransaction(event){
    event.preventDefault();

    const config = {headers: {'Content-Type': 'application/json'}}

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    if(selectedCashdrawerIdForManual === undefined){
      return
    }

    const results = await axios.post(`${ServerConfig.SERVER_URL}/tenant/tenant_cashdrawers/add_subtract`, {
      cashdrawer_id: selectedCashdrawerIdForManual,
      change_dollars: changeDollars
    }, config)

    setChangeDollars(0);
    fetchCashdrawerBalances(token);
    fetchCashdrawerList(token);
  }

  async function fetchCashdrawerTransactions(token) {
    setIsLoading(true);

    const config = {headers: {'Content-Type': 'application/json'}}

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    if(selectedCashdrawerId === undefined){
      return
    }

    const results = await axios.post(`${ServerConfig.SERVER_URL}/tenant/tenant_cashdrawers/transactions`, {
      cashdrawer_id: selectedCashdrawerId,
      start_ts_utc: startDate.getTime(),
      end_ts_utc: endDate.getTime()
    }, config)

    for (let idx in results.data) {
      let dollarvalue = "$" + (results.data[idx].amount_microdollars / 1e6).toFixed(2);
      let dollarbalance = "$" + (results.data[idx].balance / 1e6).toFixed(2);

      console.log("New dollarvalue: " + dollarvalue);

      let datetime;
      if (window.innerWidth >= 1080) {
        datetime = new Intl.DateTimeFormat('en-US',
          {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          }
        ).format(new Date(results.data[idx].ts_created));
      } else {
        datetime = new Intl.DateTimeFormat('en-US',
          {
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          }
        ).format(new Date(results.data[idx].ts_created));
      }
      _.extend(results.data[idx], {'datetime': datetime, 'value_dollars': dollarvalue, 'balance_dollars': dollarbalance});
    }

    setDailySummaries(results.data.reverse())
    setIsLoading(false);
  }


  useEffect(() => {
    fetchCashdrawerBalances(token);
    fetchCashdrawerList(token);
  }, [token])


  useEffect(() => {
    fetchCashdrawerTransactions(token);
  }, [selectedCashdrawerId, startDate, endDate, token])

  if (!token) {
    return <Redirect to="/login"/>
  }

  function formatTransaction(mt) {
    return <Typography>{mt.customer_id}: {mt.transaction_details.count_alu_lt_24oz}</Typography>
  }

  return (
    <>
      {/* balances */}
      <Grid container spacing={3}>

        {_.map(cashdrawerBalances, entry => {
          return <>
            <Grid item xs={12} sm={6} md={4} xl={3}>
              <Card key={entry.id} variant="outlined" style={{'color': 'white', 'backgroundColor': 'rgb(0,79,113)'}}>
                <CardContent>
                  {entry.name}<br style={{'height': '10px'}}/>
                  <div style={{
                    'fontSize': '32px',
                    'fontWeight': 'bold',
                    'marginBottom': '0px'
                  }}>{entry.dollarbalance}</div>
                </CardContent>
              </Card>
            </Grid>
          </>
              })
        }
      </Grid>

      <br/>
      <br/>

      {/* add or subtract money to a cashdrawer */}
      <Card style={{'overflow':'visible'}}>
        <CardContent>
      <form onSubmit={insertManualTransaction} style={{'marginBottom': 0}}>
        <Grid container spacing={3}>
          <Grid item xs={12} style={{'padding': 0}}>
            <Typography variant="h1">
              Insert manual transaction
            </Typography>
          </Grid>

          <Grid xs={12} sm={8} style={{'paddingRight': '20px'}}>
            <Typography variant="h2">
              Cashdrawer:
            </Typography>

            {availableCashdrawers.length > 0 &&
              <Select
                /*className="form-select"*/
                name="cashdrawer_manual"
                id="cashdrawer_manual"
                onChange={(event) => {
                  setSelectedCashdrawerIdForManual(event.value)
                }}  // [{value:'', label:''}, ...]
                  //defaultValue={availableCashdrawers[0]}
                options={availableCashdrawers}
                classNamePrefix="react-select"
              />
            }
          </Grid>

        <Grid xs={12} sm={4}>
          <Typography variant="h2">
            Change in dollars:
          </Typography>
          <input type="number" step="0.01" className="form-control" name="change_dollars" id="change_dollars" value={changeDollars} onChange={(e) => setChangeDollars(e.target.value)} />
        </Grid>

        <Grid xs={12} style={{'marginTop': '10px'}}>
          <Button type='submit'>Save</Button>
        </Grid>
      </Grid>
        </form>
          </CardContent>
      </Card>

      <br/>
      <br/>

      {/* selections & detailed transaction-view */}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h1">
            Detailed cashdrawer-transactions
          </Typography>
        </Grid>

        <Grid xs={12} sm={3} style={{'margin-bottom': '20px', 'padding-right': '20px'}}>
          <Typography variant="h2">
            Devices:
          </Typography>

          {availableCashdrawers.length > 0 &&
            <Select
              /*className="form-select"*/
              name="cashdrawer"
              id="cashdrawer"
              onChange={(event) => {
                setSelectedCashdrawerId(event.value)
              }}  // [{value:'', label:''}, ...]
                //defaultValue={availableCashdrawers[0]}
              options={availableCashdrawers}
              classNamePrefix="react-select"
            />
          }
        </Grid>

        <Grid xs={12} sm={2} style={{'marginBottom': '20px'}}>
          <Typography variant="h2">
            Start-Date (incl.):
          </Typography>
          <DatePicker selected={startDate} onChange={(date) => {
            setStartDate(date)
          }}
                      showTimeSelect
                      dateFormat="MMMM d, yyyy h:mm aa"
                      className="form-select"
                      popperClassName={classes.datePickerPopper}
                      />
        </Grid>

        <Grid xs={12} sm={2} style={{'marginBottom': '20px'}}>
          <Typography variant="h2">
            End-Date (incl.):
          </Typography>
          <DatePicker selected={endDate} onChange={(date) => {
            setEndDate(date)
          }}
                      showTimeSelect
                      dateFormat="MMMM d, yyyy h:mm aa"
                      className="form-select"
                      popperClassName={classes.datePickerPopper}
                      />
        </Grid>

        <Grid xs={12} sm={1}></Grid>

        <Grid xs={12} style={{'textAlign': 'center', 'marginTop': '20px', 'whiteSpace': 'pre'}}>
          {!isLoading &&
            <SortableTbl
              paging={false}
              defaultCSS={false}
              tblData={dailySummaries}
              tHead={heads}
              dKey={cols}
              search={false}
            />
          }
          {isLoading &&
            <img src={loading_gif} style={{'width': '150px'}}/>
          }
        </Grid>
      </Grid>
    </>
  )
}

export default Cashdrawers


